import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  base: process.env.VUE_APP_STATIC_PATH.replace(/^\/*/, "/").replace(
    /\/+$/,
    ""
  ),
  fallback: true,
  // base: "/box/white/",
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      aside: {
        title: "Dashboard",
        icon: "el-icon-s-home"
      },
      component: require("./components/home").default
    },
    {
      path: "/login",
      name: "login",
      component: require("./components/user/user_login").default
    },
    {
      path: "/register",
      name: "register",
      component: require("./components/user/user_register").default
    },
    {
      path: "/customers",
      name: "customers",
      aside: {
        title: "Customers",
        icon: "el-icon-s-custom"
      },
      component: require("./components/customers/customers_list").default
    },
    {
      path: "/customers/details/:id",
      name: "customers.details",
      component: require("./components/customers/customer_details").default,
      children: [
        {
          path: "services/installed/:amo_id?",
          name: "customers.details.installed_services",
          props: true,
          component: require("./components/services_v3/services-list").default,
          children: [
            {
              path: "details/:service_id",
              name: "customers.details.installed_services.details",
              props: true,
              component: require("./components/services_v3/services-details")
                .default
            },
            {
              path: "install/widget",
              name: "customers.details.installed_services.install",
              props: true,
              component: require("./components/services_v3/services-install")
                .default
            },
            {
              path: "install/script",
              name: "customers.details.installed_services.install_script",
              props: true,
              component: require("./components/services_v3/services-install-script")
                .default
            }
          ]
        }
      ]
    },
    {
      path: "/customers-services-v3",
      name: "customers-services-v3",
      aside: {
        title: "Services",
        icon: "el-icon-s-cooperation"
      },
      props: true,
      component: require("./components/services_v3/services-list").default,
      children: [
        {
          path: "details/:service_id",
          name: "customers-services-v3.details",
          props: true,
          component: require("./components/services_v3/services-details")
            .default
        }
      ]
    },
    {
      path: "/widgets",
      name: "widgets",
      aside: {
        title: "Widgets",
        icon: "el-icon-menu"
      },
      component: require("./components/widgets/widgets_list").default
    },
    {
      path: "/embedded/:name?",
      name: "embedded",
      aside: {
        title: "Embedded",
        icon: "el-icon-magic-stick"
      },
      component: require("./components/embedded/embedded_index").default
    },
    {
      path: "/periods",
      name: "periods",
      aside: {
        title: "Periods",
        icon: "el-icon-time"
      },
      component: require("./components/periods/periods_list").default
    },
    {
      path: "/texts",
      name: "texts",
      aside: {
        title: "Texts",
        icon: "el-icon-document"
      },
      component: require("./components/texts/texts_list").default
    },
    {
      path: "/texts/details/:id",
      name: "texts.details",
      component: require("./components/texts/texts_details").default
    },
    {
      path: "/amo-widgets",
      name: "amo_widgets",
      aside: {
        title: "AMO widgets",
        icon: "el-icon-magic-stick"
      },
      component: require("./components/widgets_amo/widgets_list").default
    },
    {
      path: "/vendors/:id?",
      name: "vendors",
      aside: {
        title: "Vendors",
        icon: "el-icon-s-custom"
      },
      component: require("./components/vendors/vendors_list").default
    },
    {
      path: "/amo-licenses/:id?",
      name: "amo-licenses",
      aside: {
        title: "AMO Licenses",
        icon: "el-icon-money"
      },
      component: require("./components/amo_licenses/amo_licenses_list").default
    },
    {
      path: "/keys",
      name: "keys",
      aside: {
        title: "Keys",
        icon: "el-icon-key"
      },
      component: require("./components/keys/keys_list").default
    },
    {
      path: "/customers-services",
      name: "customers-services",
      redirect: to => {
        return { name: "customers-services-v3" };
      }
    },
    {
      path: "/customers-services-v2",
      name: "customers-services-v2",
      redirect: to => {
        return { name: "customers-services-v3" };
      }
    },
    {
      path: "/menu-editor",
      name: "menu-editor",
      aside: {
        title: "Edit menu",
        icon: "el-icon-more-outline"
      },
      component: require("./components/menu/menu-editor").default
    },
    {
      path: "/integrations",
      name: "integrations.list",
      component: require("./components/integrations/integrations-list").default
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (
    JSON.parse(process.env.VUE_APP_KEYCLOAK_DISABLE_AUTH) === true ||
    to.matched.some(record => (record.meta || {}).skipAuth)
  ) {
    next();
  } else {
    if (router.app.$keycloak.authenticated) {
      router.app.$store.commit("user/setToken", router.app.$keycloak.token);
      router.app.$store.commit(
        "user/setUser",
        router.app.$keycloak.tokenParsed
      );
      next();
    } else {
      const loginUrl = router.app.$keycloak.createLoginUrl();
      window.location.replace(loginUrl);
    }
  }
});

export default router;
